export default "__VITE_ASSET__BbSZrPYY__"